var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSterlingSign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80 152c0-48.6 39.4-88 88-88l7.1 0c9.5 0 18.9 1.5 27.8 4.5l80 26.7c8.4 2.8 17.4-1.7 20.2-10.1s-1.7-17.4-10.1-20.2l-80-26.7c-12.2-4.1-25-6.2-37.9-6.2L168 32C101.7 32 48 85.7 48 152l0 104-32 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l31.9 0C46.3 346.2 31 403.1 3.1 454.3l-1.1 2c-2.7 5-2.6 11 .3 15.8S10.4 480 16 480l288 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L42.1 448c23.5-50.1 36.4-104.6 37.8-160L240 288c8.8 0 16-7.2 16-16s-7.2-16-16-16L80 256l0-104z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSterlingSign);
export default __webpack_public_path__ + "static/media/sterling-sign.86bb3747433bb1cb82bbd120f112d420.svg";
export { ForwardRef as ReactComponent };